import { h, Component } from 'preact';
import { connect } from 'preact-redux';

import { find } from 'lodash';

import Sidebar from '../components/Sidebar';
import LoadingSpinner from './LoadingSpinner';
import Icon from './Icon';

import { clickevent } from '../client/tracking';

import formatDate from '../util/format-date';

import './BlogPostPage.scss';

const BlogPostPage = ({ postid, post, loading }) => {
    const canonical = `https://www.jogitanacs.info${post.sitePath}`;
    const mailto = `mailto:?subject=${post.attributes.title}&body=${encodeURIComponent(canonical)}`;
    const facebook = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(canonical)}`;
    const twitter = `https://twitter.com/share?url=${encodeURIComponent(canonical)}&text=${post.attributes.title}`;

    const trackShare = (service, position) => () => clickevent('Share', `${service}-${position}`, post.sitePath);

    return (
        <div class="page">
            <main class="page-main">
                <div class="page-container">
                    <LoadingSpinner visible={loading} />
                    
                    <h1>{ post.attributes.title }</h1>
                    { formatDate(post.attributes.date) }
                    
                    &nbsp;&mdash;&nbsp;

                    Dr. Béres-Deák Attila

                    <section class="content-section sharing-buttons">
                        <a class="share-button share-button--facebook" onClick={trackShare('Facebook', 'top')} title="Megosztás a Facebookon" target="_blank" rel="external noopener" href={facebook}>
                            <Icon id="icon-facebook" />
                            Facebook
                        </a>
                        <a class="share-button share-button--twitter" onClick={trackShare('Twitter', 'top')} title="Megosztás Twitteren" target="_blank" rel="external noopener" href={twitter}>
                            <Icon id="icon-twitter" />
                            Twitter
                        </a>
                        <a class="share-button share-button--email" onClick={trackShare('Email', 'top')} title="Elküldés e-mailben" href={mailto}>
                            <Icon id="icon-email" />
                            Email
                        </a>
                    </section>

                    <div class="markdown-content" dangerouslySetInnerHTML={{ __html: post.html }} />
                    { (post.attributes.tags || []).join(', ') }

                    <section class="content-section sharing-buttons">
                        <a class="share-button share-button--facebook" onClick={trackShare('Facebook', 'bottom')} title="Megosztás a Facebookon" target="_blank" rel="external noopener" href={facebook}>
                            <Icon id="icon-facebook" />
                            Facebook
                        </a>
                        <a class="share-button share-button--twitter" onClick={trackShare('Twitter', 'bottom')} title="Megosztás Twitteren" target="_blank" rel="external noopener" href={twitter}>
                            <Icon id="icon-twitter" />
                            Twitter
                        </a>
                        <a class="share-button share-button--email" onClick={trackShare('Email', 'bottom')} title="Elküldés e-mailben" href={mailto}>
                            <Icon id="icon-email" />
                            Email
                        </a>
                    </section>

                    <br/>
                    <br/>
                    <a href="/blog">Vissza a blogbejegyzésekhez</a>
                </div>
            </main>
            <Sidebar />
        </div>
    );
};

const mapStateToProps = (state, { postid }) => ({
    post: find(state.pages, p => p.sitePath === `/blog/${postid}`),
    loading: state.loading
});

export default connect(mapStateToProps)(BlogPostPage);


// WEBPACK FOOTER //
// ./src/components/BlogPostPage.js